export default {
    //apiBase: '/api',// 'http://10.9.146.69:8080/api/v1',//测试机
    // apiBase: 'http://10.9.146.69:8080/api/v1',//测试机
    // apiBase: 'http://10.9.146.44:9210/api/v1',//林
     apiBase: "/api",
    // apiBase: "/basic-api",
}
